export class CountUp {
    constructor(public id: string, public startDate: Date, public title: string) { }
}